import { AssetApprovalActionModel, AssetApprovalModel } from '@casops/store/apis/assetApprovalsApi';
import { ReactElement, useMemo } from 'react';
import AssetApprovalForm from '../form/AssetApprovalForm';
import { useRenderKey } from '@casops/hooks/useRenderKey';

interface ApprovalManagerProps {
  item: AssetApprovalModel;
}

export const ApprovalManager = ({ item }: ApprovalManagerProps): ReactElement | null => {
  const action = useMemo<AssetApprovalActionModel | undefined>(
    () => item.actions?.[0],
    [item.actions],
  );

  // Change the render key if the action changes.
  const renderKey = useRenderKey({ action });

  return action ? (
    <AssetApprovalForm
      key={renderKey} // Reset the form if the action is changed because the fields need to load new values.
      id={item.id}
      approvalStatus={item.sts}
      action={item.actions[0]}
    />
  ) : null;
};

export default ApprovalManager;
